var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-text-field", {
        staticClass: "pt-0 mb-0",
        attrs: {
          value: _vm.currentCase ? _vm.currentCase.name : "",
          readonly: "",
          outlined: "",
          placeholder: "Select case",
          dense: "",
          color: "primary",
          messages: _vm.disableUrlInput ? null : "a",
          loading: _vm.isGetCasePending,
          rules: _vm.rules,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "append-outer",
              fn: function () {
                return [
                  _c("DialogForm", {
                    attrs: {
                      title: "Open Case",
                      "submit-text": "open",
                      "disable-submit": !_vm.caseToOpen.id,
                      submit: _vm.openCase(_vm.caseToOpen),
                      "max-width": 0,
                      "dialog-props": { width: "unset" },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            !_vm.browseBtnSmall
                              ? _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      attrs: {
                                        outlined: "",
                                        color: "primary",
                                        small: "",
                                      },
                                    },
                                    on
                                  ),
                                  [_vm._v("Browse")]
                                )
                              : _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      attrs: {
                                        color: "primary",
                                        small: "",
                                        icon: "",
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-folder-open-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c("FolderTreeSelect", {
                              attrs: {
                                "show-cases": "",
                                "select-only": "case",
                              },
                              model: {
                                value: _vm.caseToOpen,
                                callback: function ($$v) {
                                  _vm.caseToOpen = $$v
                                },
                                expression: "caseToOpen",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ]
              },
              proxy: true,
            },
            !_vm.disableUrlInput
              ? {
                  key: "message",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "text-caption" }, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                _vm.showURLField = !_vm.showURLField
                              },
                            },
                          },
                          [_vm._v("Use case link")]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c(
        "v-form",
        {
          model: {
            value: _vm.isValidURL,
            callback: function ($$v) {
              _vm.isValidURL = $$v
            },
            expression: "isValidURL",
          },
        },
        [
          _vm.showURLField
            ? _c("v-text-field", {
                staticClass: "mx-4",
                attrs: {
                  dense: "",
                  outlined: "",
                  placeholder: "Paste case url",
                  rules: _vm.urlRules,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "append-outer",
                      fn: function () {
                        return [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                outlined: "",
                                color: "primary",
                                small: "",
                                disabled: !_vm.isValidURL,
                              },
                              on: { click: _vm.submitUrl },
                            },
                            [_vm._v(" Ok ")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1348596683
                ),
                model: {
                  value: _vm.url,
                  callback: function ($$v) {
                    _vm.url = $$v
                  },
                  expression: "url",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }